import Immutable from 'immutable';
import * as types from './Reports.types';

const initialState = {
    reportType: 1,
    platform: 'both',
    coupaOrders: 1,
    personalOrders: 1,
    managerOrders: 1,
    startDate: null,
    endDate: null,
    exporting: false,
}

export default function (state = initialState, action) {
    state = Immutable.fromJS(state);
    switch (action.type) {
        case types.EXPORT_REPORT:
            return state.setIn(['exporting'], true).toJS();

        case types.EXPORT_REPORT_SUCCESS:
            return state.setIn(['exporting'], false).toJS();

        case types.EXPORT_REPORT_ERROR:
            return state.setIn(['exporting'], false).toJS();

        case types.SET_REPORT_TYPE:
            return state.setIn(['reportType'], action.payload).toJS();

        case types.SET_PLATFORM:
            return state.setIn(['platform'], action.payload).toJS();

        case types.SET_ORDER_TYPE:
            return state.setIn([action.payload.name], action.payload.value).toJS();

        case types.SET_START_DATE:
            return state.setIn(['startDate'], action.payload).toJS();

        case types.SET_END_DATE:
            return state.setIn(['endDate'], action.payload).toJS();

        default:
            return state.toJS();
    }
}